import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getProcedureTypeList as getProcedureTypeListApi,
	getProcedureTypeListQuery as getProcedureTypeListQueryApi,
	getProcedureType as getProcedureTypeApi,
	addNewProcedureTypeApi,
	updateProcedureTypeApi,
	deleteProcedureTypeApi,
	checkProcedureTypeExistsApi,
} from '../../helpers/procedure_type/api_helper';

export const getProcedureTypeList = createAsyncThunk(
	'procedureType/getProcedureTypeList',
	async () => {
		try {
			const response = await getProcedureTypeListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los tipos de trámite.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getProcedureTypeListQuery = createAsyncThunk(
	'procedureType/getProcedureTypeListQuery',
	async params => {
		try {
			const response = getProcedureTypeListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getProcedureType = createAsyncThunk(
	'procedureType/getProcedureType',
	async procedure_type_id => {
		try {
			const response = await getProcedureTypeApi(procedure_type_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el tipo de trámite.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewProcedureType = createAsyncThunk(
	'procedureType/addNewProcedureType',
	async procedure_type => {
		try {
			const response = await addNewProcedureTypeApi(procedure_type);
			toast.success('Tipo de Trámite agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el tipo de trámite.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateProcedureType = createAsyncThunk(
	'procedureType/updateProcedureType',
	async procedure_type => {
		try {
			const response = await updateProcedureTypeApi(procedure_type);
			toast.success('Tipo de Trámite actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el tipo de trámite.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteProcedureType = createAsyncThunk(
	'procedureType/deleteProcedureType',
	async procedure_type => {
		try {
			const response = await deleteProcedureTypeApi(procedure_type._id);
			toast.success('Tipo de Trámite eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return procedure_type;
		} catch (error) {
			toast.error('Error al eliminar el tipo de trámite.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkProcedureTypeExists = createAsyncThunk(
	'procedureType/checkProcedureTypeExists',
	async name => {
		try {
			const response = await checkProcedureTypeExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
